'use strict';

/**
 * Decodes a string containing HTML entities.
 * @param {string} str - The string to decode.
 * @returns {string} The decoded string.
 */
function decode(str) {
    let txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}

/**
 * Normalizes a string to contain only lowercase a-z, 0-9, and '-' characters.
 * Removes accents, special characters, and replaces spaces with hyphens.
 * @param {string} s - The string to normalize.
 * @returns {string|null} The normalized string or null if input is undefined.
 */
function normalizeString(s) {
    if (s !== undefined) {
        let str = s;
        str = decode(str);
        str = str.replaceAll(/[àáâãäå]/g, 'a');
        str = str.replaceAll(/[èéêë]/g, 'e');
        str = str.replaceAll(/[ìíîï]/g, 'i');
        str = str.replaceAll(/[òóôõö]/g, 'o');
        str = str.replaceAll(/[ùúûü]/g, 'u');
        str = str.replaceAll(/([/,!\\^${}[]\(\)\.\*\+\?\|<>'&])/g, '');
        str = str.replaceAll('ñ', 'n');
        str = str.replaceAll('ç', 'c');
        str = str.replaceAll('--', '-');
        str = str.trim();
        return str;
    }
    return null;
}

module.exports = { normalizeString };
